import { useNavigate, useParams } from "react-router-dom";
import ProjectsForm from "../components/ProjectsForm";
import { useGetAxe } from "../api/getAxes";
import { useEffect } from "react";
import { selectAuthentificated, selectCurrentUser } from "../../../auth/AuthUserSlice";
import { useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import { clients } from "../../../lib/axios";
import { CheckIfExist } from "../../../App";


const AddProjects = () => {

  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser); // preferred_username

  useEffect(() => {

    const check = async () => { 
      /**
       * Check if logged user has structure
       */
      const hasStructure = await CheckIfExist(currentUser?.preferred_username);
      if(!hasStructure) {
        navigate('/create/structure');
      }
    };

    check();

  }, []);
  

  return (
    <ProjectsForm />
  );
}
export default AddProjects;